import { parseJson } from "../../utils/utils";

export const onRowUpdateError = (pushNotification, I18n) => {
    pushNotification({
        open: true,
        message: I18n.translate`Somethings went wrong update field`,
        type: "error",
        timeout: "short",
    });
};

export const onCellHighlightDataGrid = (params) => {
    const { field, row } = params || {};
    const { oldRow = "{}" } = row || {};
    const parsedOldRow = parseJson(oldRow);
    return Object.keys(parsedOldRow)?.length && row[field] !== parsedOldRow[field]
        ? "highlight"
        : "";
};
